import { render, staticRenderFns } from "./workflow-record-list.vue?vue&type=template&id=78ef0188&scoped=true"
import script from "./workflow-record-list.vue?vue&type=script&lang=js"
export * from "./workflow-record-list.vue?vue&type=script&lang=js"
import style0 from "./workflow-record-list.vue?vue&type=style&index=0&id=78ef0188&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78ef0188",
  null
  
)

export default component.exports